import { getCurrentUserEmail } from '../auth';
import { getEightDInfoId } from '../eightDInfoStore';

const toIsoOrNull = (date) => {
  if (!date) return null;
  try {
    const d = date instanceof Date ? date : new Date(date);
    return isNaN(d.getTime()) ? null : d.toISOString();
  } catch {
    return null;
  }
};

export const buildD3Payload = ({
  eightDInfoId,
  responsiblePerson = '',
  plannedDate = null,
  achievedDate = null,
  containmentRows = [],
  sortingResults = [],
  whatLearnedFromSorting = '',
  isMarkedDeliveredOKParts = false,
  uploadedFiles = [],
  isDisabled = false,
  containmentToRemove = [],
  attachmentsToRemove = [],
  createdBy = getCurrentUserEmail(),
  modifiedBy = getCurrentUserEmail(),
  d3Id = null,
}) => {
  const finalEightDInfoId = Number(eightDInfoId || getEightDInfoId());
  const nowIso = new Date().toISOString();

  const ContainmentDetails = (containmentRows || []).map((row) => ({
    ...(row.id ? { D3ContainmentId: Number(row.id) } : {}),
    EightDInfoId: finalEightDInfoId,
    Containment: row.containment || '',
    Action: row.action || '',
    Responsible: row.responsible || '',
    TargetDate: toIsoOrNull(row.date) || nowIso,
    Status: row.status || '',
    CreatedBy: createdBy || '',
    CreatedOn: nowIso,
    ModifiedBy: modifiedBy || '',
    ModifiedOn: nowIso,
  }));

  const SortingResults = (sortingResults || []).map((r) => ({
    ...(r.id ? { D3SortingResultId: Number(r.id) } : {}),
    EightDInfoId: finalEightDInfoId,
    Location: r.location || '',
    IsMaterialSorted: r.materialSorted === 'Yes' || r.isMaterialSorted === true,
    Quantity: Number(r.quantity) || 0,
    Comment: r.comments || r.comment || '',
    CreatedBy: createdBy || '',
    CreatedOn: nowIso,
    ModifiedBy: modifiedBy || '',
    ModifiedOn: nowIso,
  }));

  const Attachments = (uploadedFiles || []).filter(f => !f.isExisting).map((f) => {
    const base64Data = f.preview || '';
    const attachmentData = base64Data.startsWith('data:') ? base64Data : base64Data ? `data:${f.file?.type || 'image/jpeg'};base64,${base64Data}` : '';
    return {
      EightDInfoId: finalEightDInfoId,
      AttachmentName: f.file?.name || f.localPath || '',
      AttachmentType: f.file?.type || '',
      AttachmentData: attachmentData,
      CreatedBy: createdBy || '',
      CreatedOn: nowIso,
      ModifiedBy: modifiedBy || '',
      ModifiedOn: nowIso,
    };
  });

  return {
    ...(d3Id ? { D3Id: d3Id } : {}),
    EightDInfoId: finalEightDInfoId,
    IsMarkedDeliveredOKParts: Boolean(isMarkedDeliveredOKParts),
    WhatLearnedFromSorting: whatLearnedFromSorting || '',
    ResponsiblePerson: responsiblePerson || '',
    PlannedDate: toIsoOrNull(plannedDate),
    AchievedDate: toIsoOrNull(achievedDate),
    CreatedBy: createdBy || '',
    CreatedOn: nowIso,
    ModifiedBy: modifiedBy || '',
    ModifiedOn: nowIso,
    IsDisabled: Boolean(isDisabled),
    ContainmentDetails,
    SortingResults,
    Attachments,
    AttachmentsToRemove: attachmentsToRemove || [],
    ContainmentDetailsToRemove: containmentToRemove || [],
  };
};
